import { z } from "zod";

export const addUserSchema = z.object({
  username: z.string().min(3, "Username must be at least 3 characters"),
  email: z.string().email("Invalid email address"),
  groups: z.array(z.string()).min(1, "Select at least one group"),
});